import { render, staticRenderFns } from "./PortafolioVentas.vue?vue&type=template&id=72e015ea&scoped=true"
import script from "./PortafolioVentas.vue?vue&type=script&lang=js"
export * from "./PortafolioVentas.vue?vue&type=script&lang=js"
import style0 from "./PortafolioVentas.vue?vue&type=style&index=0&id=72e015ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e015ea",
  null
  
)

export default component.exports